// Each wheel pairs its face image with that image's segment prices, listed
// CLOCKWISE STARTING AT THE TOP (the segment under the marker at rotation 0).
// SpinTarget rotates segment `i` to the marker via (SEG_COUNT - i) * SEG_DEG, so
// this order is what makes the announced price match the segment the wheel lands on.
// Editing an image means re-transcribing its prices here, and vice versa.
export interface SpinWheelConfig {
  image: string;
  prices: number[];
}

export const SPIN_WHEELS: SpinWheelConfig[] = [
  {
    image:  '/images/spin-wheel-1.png',
    prices: [ 3847, 9213, 5672, 7109, 4338, 8921, 6455, 3214, 9687, 5043, 7776, 4592 ],
  },
  {
    image:  '/images/spin-wheel-2.png',
    prices: [ 6128, 8354, 3591, 9842, 4207, 7463, 5819, 3976, 8617, 6290, 4735, 9108 ],
  },
  {
    image:  '/images/spin-wheel-3.png',
    prices: [ 5364, 7928, 3182, 9451, 6703, 4516, 8247, 3839, 7015, 9673, 5528, 4061 ],
  },
];

export const randomSpinWheelIndex = (): number =>
  Math.floor(Math.random() * SPIN_WHEELS.length);
